<template>
    <div class="main_container">
        <div class="with_back_btn_con" v-if="this.hideRecipient == false">
            <div class="go_back_container">
                <span class="icon-next mr-3"  @click="CloseModal()"><IconBase width="24" height="24"><IconArrowBack /></IconBase></span><span class="ap_text"> Add a new address </span>
            </div>
        </div>    


            <v-container grid-list-xl>
                <v-layout row wrap>
                    <form v-if="!is_manual" id="SearchAddress" class="standard-form"  data-vv-scope="SearchAddress">
                        <p class="font-xs">Can't find your address? <a href="javascript:void(0);" @click="is_manual = true;">Enter it manually <span class="icon_span"><IconBase><IconPlus /></IconBase></span></a></p>
                        <v-layout row wrap class="" v-if="this.hideRecipient == false">
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <label for="" class="subheading">Recipient / Company name</label>
                                <v-text-field
                                    id="search_name"
                                    single-line
                                    outline
                                    class="full-width"
                                    
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs6 sm6 md6 lg6 xl6>
                                <label for="" class="subheading">Postcode</label>
                                <v-text-field
                                    v-model="search_postcode"
                                    id="search_postcode"
                                    single-line
                                    outline
                                    class="full-width"
                                    v-validate="'required|decimal|max:4|min:3'"
                                    :error-messages="errors.first('SearchAddress.search_postcode')"
                                    data-vv-name="search_postcode"
                                    data-vv-scope="SearchAddress"
                                    data-vv-validate-on="input"
                                    :class="{valid_entry: fields.$SearchAddress && fields.$SearchAddress.search_postcode && fields.$SearchAddress.search_postcode.valid}"
                                    v-on:keyup="CheckPostCode('search_postcode')"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <div class="relative">
                                    <label for="" class="subheading">Address</label>
                                    <v-text-field
                                        v-model="search_address"
                                        id="search_address"
                                        single-line
                                        outline
                                        class="full-width"
                                        v-validate="'required|max:500'"
                                        :error-messages="errors.first('SearchAddress.search_address')"
                                        data-vv-name="search_address"
                                        data-vv-scope="SearchAddress"
                                        data-vv-validate-on="input"
                                        :class="[{valid_entry: fields.$SearchAddress && fields.$SearchAddress.search_address && fields.$SearchAddress.search_address.valid}, {bggray : disable_status_address}]"
                                        :disabled = "disable_status_address"
                                        ref="focus_search_address"
                                        placeholder="eg. 20 John St or 1/20 John St"
                                        v-on:keyup="CheckAddress('search_address')"
                                    ></v-text-field>
                                    <v-progress-circular
                                        indeterminate
                                        class="circle_loading"
                                        :size="30"
                                        color="#444444"
                                        v-if="this.loading == true"
                                        
                                        ></v-progress-circular>
                                    <div class="absolute search_results" v-if="this.address_search_result.length > 0">
                                        <div v-for="(item, index) in address_search_result" class="search_results_con" :key ="item.id" @click="selectOnGMAPList(item)">
                                        {{ item.description }} 
                                        <div v-if="index == address_search_result.length - 1" class="powered_by_google_con"><img src="../assets/powered-by-google.png" class="powered_by_google"></div>
                                        </div>
                                    </div>
                                    <div class="absolute search_results" v-if="this.no_result == true">
                                        <div class="search_results_con">
                                        Cant find your address
                                        </div>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-spacer></v-spacer>
                    </form>

                    <form v-if="is_manual" id="formNewAddress" class="standard-form" data-vv-scope="formNewAddress">
                        <p class="font-xs"><a href="javascript:void(0);" @click="is_manual = false;">Try searching for your address again<span class="icon_span"><IconBase><IconMinus /></IconBase></span></a></p>
                        
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12 lg12 xl12 v-if="this.hideRecipient == false">
                                <label for="" class="subheading">Recipient / Company Name</label>
                                <v-text-field
                                    
                                    v-model="address_name"
                                    id="address_name"
                                    single-line
                                    outline
                                    class="full-width"
                                    v-validate="'required|max:100'" 
                                    :error-messages="errors.first('formNewAddress.address_name')"
                                    data-vv-name="address_name"
                                    data-vv-scope="formNewAddress"
                                    :class="{valid_entry: fields.$formNewAddress && fields.$formNewAddress.address_name && fields.$formNewAddress.address_name.valid}"
                                    
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm6 md6 lg6 xl6>
                                <label for="" class="subheading">Unit/House No.</label>
                                <v-text-field
                                    label="## / ##"
                                    v-model="street_no"
                                    id="street_no"
                                    single-line
                                    outline
                                    class="full-width"
                                    v-validate="'required|max:20'"
                                    :error-messages="errors.first('formNewAddress.street_no')"
                                    data-vv-name="street_no"
                                    data-vv-scope="formNewAddress"
                                    data-vv-validate-on="input"
                                    :class="{valid_entry: fields.$formNewAddress && fields.$formNewAddress.street_no && fields.$formNewAddress.street_no.valid}"
                                    
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6>
                                <label for="" class="subheading">Street Address</label>
                                <v-text-field
                                    label="E.g. Sample Street"
                                    v-model="address"
                                    id="address"
                                    single-line
                                    outline
                                    class="full-width"
                                    v-validate="'required|max:100'"
                                    :error-messages="errors.first('formNewAddress.address')"
                                    data-vv-name="address"
                                    data-vv-scope="formNewAddress"
                                    data-vv-validate-on="input"
                                    :class="{valid_entry: fields.$formNewAddress && fields.$formNewAddress.address && fields.$formNewAddress.address.valid}"
                                ></v-text-field>
                            </v-flex>
                            
                            <v-flex xs6 sm6 md4 lg4 xl4>
                                <label for="postcode" class="subheading">Postcode</label>
                                <v-text-field
                                    label="Postcode"
                                    v-model="postcode"
                                    id="postcode"
                                    single-line
                                    outline
                                    class="full-width"
                                    v-validate="'required|decimal|max:4|min:3'"
                                    :error-messages="errors.first('formNewAddress.postcode')"
                                    data-vv-name="postcode"
                                    data-vv-scope="formNewAddress"
                                    data-vv-validate-on="input"
                                    :class="{valid_entry: fields.$formNewAddress && fields.$formNewAddress.postcode && fields.$formNewAddress.postcode.valid}"
                                    v-on:keyup="CheckPostCode('postcode')"
                                    autocomplete="off"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm6 md4 lg4 xl4>
                                <label for="state" class="subheading">State</label>
                                <v-overflow-btn
                                    v-model="state"
                                    id="state"
                                    :items="au_states"
                                    return-object
                                    editable
                                    flat
                                    outline
                                    v-validate="'required|max:100'"
                                    :error-messages="errors.first('formNewAddress.state')"
                                    data-vv-name="state"
                                    data-vv-scope="formNewAddress"
                                    :class="[{valid_entry: fields.$formNewAddress && fields.$formNewAddress.state && fields.$formNewAddress.state.valid},  {bggray : disable_manual_address}]"
                                    :disabled = "disable_manual_address"
                                ></v-overflow-btn>
                            </v-flex>
                            <v-flex  xs12 sm12 md4 lg4 xl4>
                                <label for="state" class="subheading">Suburb</label>
                                <v-overflow-btn
                                    v-model="suburb"
                                    id="state"
                                    :items="au_suburb"
                                    return-object
                                    editable
                                    flat
                                    outline
                                    v-validate="'required|max:100'"
                                    :error-messages="errors.first('formNewAddress.suburb')"
                                    data-vv-name="suburb"
                                    data-vv-scope="formNewAddress"
                                    :class="[{valid_entry: fields.$formNewAddress && fields.$formNewAddress.suburb && fields.$formNewAddress.suburb.valid},  {bggray : disable_manual_address}]"
                                    :disabled = "disable_manual_address"
                                ></v-overflow-btn>
                            </v-flex>
                        </v-layout>
                    </form>
                </v-layout>
            </v-container>
 
            <v-divider v-if="this.hideRecipient == false"></v-divider>
            <v-spacer v-if="this.hideRecipient == false"></v-spacer>
            <v-layout row wrap align-center justify-center v-if="this.hideRecipient == false">
                <v-flex xs12 sm12 md12 lg12 xl12 align-center>
                    <div class="btn_container">
                        <v-btn round flat dark class="next-btn"  @click="Confirm()" :class="{ next_btn_active: AllFieldsValid }">Confirm<span class="icon-next"><IconBase><IconForward /></IconBase></span></v-btn>
                    </div>
                </v-flex>
            </v-layout>
    </div>
    
</template>


<script>
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconPlus from '@/components/icons/plus.vue'
import IconMinus from '@/components/icons/minus.vue'
import json_data from '../postcode2.json'
import Globals from '@/assets/scripts/global-functions.js'



export default {
    name: "ComponentAddressForm",
    components: {
        IconArrowBack,
        IconBase,
        IconForward,
        IconPlus,
        IconMinus,
        Globals,
    },
    props: {
        'current_process': String,
        'hideRecipient' : Boolean,
        'mountedData' : Object,
    },
    data: function () {
        return {
            is_manual: false,
            is_form_valid: false,
            au_states: ['NSW','WA','QLD','SA','VIC','TAS','NT','ACT'],
            au_suburb: [],
            address_name: "",
            street_no: "",
            address: "",
            suburb: "",
            state: "",
            postcode: "",
            search_address: "",
            search_postcode: "",
            default_required_msg: "This field is required to proceed.",
            dictionary: {
                custom: {
                    address_name: {
                        required: () => "This field is required to proceed.",
                    },
                    search_address:{
                        required: () => "This field is required to proceed.",
                    },
                    street_no: {
                        required: () => "This field is required to proceed.",
                        max: 'Cannot exceed more than 10 characters'
                    },
                    address: {
                        required: () => "This field is required to proceed.",
                        max: 'Cannot exceed more than 255 characters'
                    },
                    postcode: {
                        required: () => "This field is required to proceed.",
                        max: 'Cannot exceed more than 4 characters'
                    },
                    search_postcode:{
                        required: () => "This field is required to proceed.",
                        max: 'Cannot exceed more than 4 characters',
                        decimal: 'Only numbers are allowed',
                        min: 'Minumum of 3 characters',
                    },
                    suburb: {
                        required: () => "This field is required to proceed.",
                        max: 'Cannot exceed more than 60 characters'
                    },
                    state: {
                        required: () => "This field is required to proceed.",
                    }
                }
            },
            disable_status_address: true,
            datas: json_data,
            disable_manual_address: true,
            place_id: "",
            api_key: document.getElementsByName('cfw_global_google_key')[0].content,
            long: "",
            lat: "",
            loading: false,
            address_search_result: [],
            address_search_selected: [],
            no_result: false,

        }
    },
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            if(this.is_manual){
                if(this.fields.$formNewAddress) {
                    let fld = this.fields.$formNewAddress;
                    if(fld.address_name && this.hideRecipient == true) {
                        if(fld.address_name.valid && fld.address.valid && fld.postcode.valid && fld.suburb.valid && fld.state.valid) { _isvalid = true; }
                    }else{
                        if(fld.address.valid && fld.postcode.valid && fld.suburb.valid && fld.state.valid) { _isvalid = true; }
                    }
                }
            }else{
                if(this.fields.$SearchAddress) {
                    let fld = this.fields.$SearchAddress;
                    if(fld.search_address) {
                        if(fld.search_address.valid && fld.search_postcode.valid ) { _isvalid = true; }
                    }
                    
                }
            }

            return _isvalid;
        }
    },
    watch: {
        AllFieldsValid: function(newVal, oldVal) {
            if(newVal == true){
                this.$emit('next_btn_active', true);
            }else{
                this.$emit('next_btn_active', false);
            }
        }
    },
    
    methods: {
        Confirm() {
            if(this.is_manual) {
                this.AddNewAddress();
            } else {
                this.AddSearchedAddress();
            }

        },
        ClearData() {
            this.address_name = "";
            this.street_no = "";
            this.address = "";
            this.suburb = "";
            this.postcode = "";
            this.state = "";
            this.$validator.reset();
        },
        AddSearchedAddress() {
            //SearchAddress
            this.$validator.validateAll("SearchAddress").then(result => {
                if (result) {                   
                    let _data = {
                        "postcode": this.search_postcode,
                        "address": this.search_address,
                        "is_manual" : false
                    }

                    if(this.hideRecipient == true){
                        this.$emit('your_address', _data);
                    }else{
                        this.$root.$parent[this.current_process].Addresses.push(_data);
                        Globals.SessionUpdate(this.current_process);
                        this.ClearData();
                        this.CloseModal();
                    }
                } else {
                    console.error("There seem to be an error in your entries.");
                }
            });
        },
        AddNewAddress() {
            this.$validator.validateAll("formNewAddress").then(result => {
                if (result) {
                    let _data = {
                        "name": this.address_name,
                        "street_number": this.street_no,
                        "address": this.address,
                        "suburb": this.suburb,
                        "state": this.state,
                        "postcode": this.postcode,
                        "isselected": false,
                    }

                    if(this.hideRecipient == true){
                        this.$emit('your_address', _data);
                    }else{
                        this.$root.$parent[this.current_process].Addresses.push(_data);
                        Globals.SessionUpdate(this.current_process);
                        this.ClearData();
                        this.CloseModal();
                    }


                   
                } else {
                    console.error("There seem to be an error in your entries.");
                }
            });
            
        },
        CloseModal() {
            this.ClearData();
            this.$emit('close-modal')
        },
        CheckPostCode(_input){
            if(this.is_manual){
                let fld = this.fields.$formNewAddress;
                this.suburb = "";

                if(this[_input].length == 4 && fld.postcode.valid){
                    let res = this.Filter(this.postcode);
                    this.CheckAddressManual(res); 
                    this.EnableInputColor('disable_manual_address');
                    
                }
                else{
                    this.DisableInputColor('disable_manual_address');
                }
            }else{

                let fld = this.fields.$SearchAddress;
                this.search_address = "";
                if(this[_input].length == 4 && fld.search_postcode.valid){
                    this.CheckPostCodeSearch(); 
                    this.EnableInputColor('disable_status_address');
                }
                else{
                    this.DisableInputColor('disable_status_address');
                }
            }
        },
        EnableInputColor(_input){
            this[_input] = false;
        },
        DisableInputColor(_input){
            this[_input] = true;
        },
        Filter(searchKey) {
            let arr = this.datas;
            return arr.filter(function(obj) {
                return Object.keys(obj).some(function(key) {
                    return obj['postcode'].includes(searchKey);
                })
            });
        },
        CheckPostCodeSearch(){
        
            let res = this.Filter(this.search_postcode);
            //let res = [];

            if(res.length <= 0 ){
                this.no_result = false;

                //check in google maps api
                let url = '/utilities/api_get_placeid.json?post_code=' + encodeURI(this.search_postcode);
                let GoogleMapAPI_ = Globals.AxiosGet(url);
                let self = this;
                GoogleMapAPI_.then(function (response) {
                    if(response.status == 200){
                        let place_id_data = JSON.parse(response.data.api_call_send.response.body);

                        if(response.data.api_call_send.response.status == 200 && place_id_data.status == "OK"){
                            let place_id = place_id_data.predictions[0].place_id;
                            let url = '/utilities/api_get_long_lat.json?place_id=' + encodeURI(place_id);
                            let GetLongLat_ = Globals.AxiosGet(url);
                            GetLongLat_.then(function (response) {
                                if(response.status == 200){
                                    let long_lat_data = JSON.parse(response.data.api_call_send.response.body);
                                    if(response.data.api_call_send.response.status == 200 && long_lat_data.status == "OK"){
                                        self.lat = long_lat_data.result.geometry.location.lat;
                                        self.long = long_lat_data.result.geometry.location.lng;
                                        setTimeout(() => {
                                            self.$refs.focus_search_address.focus();
                                        }, 300);
                                    }
                                }
                            }).catch(function (response) { 
                                console.error('Get Long/Lat', response);
                            });
                        }else{
                            self.no_result = true;
                        }
                    }


                })
                .catch(function (response) { 
                    console.error('Google Map API', response);
                });
            }else{
                //FOCUS on search address
                this.search_address = '';
                let search = this.search_postcode;
                this.long = res[0].long;
                this.lat = res[0].lat;
                
                setTimeout(() => {
                    this.$refs.focus_search_address.focus();
                }, 300);
            }
        },
        CheckAddressManual(res){
            this.state = "";
            this.au_suburb = [];
            this.state = res[0].State;
            this.PushToAUSuburb(res);

        },
        PushToAUSuburb(res){
            for(let i=0;i<res.length;i++){
                var text = res[i].locality;
                text = text.toLowerCase()
                .split(' ')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
                this.au_suburb.push(text);
            }
        },
        CheckAddress(_input){
            let autocomplete;
            
            if(this.is_manual){

            }else{

                let fld = this.fields.$SearchAddress;
                if(this[_input].length > 6 && fld.search_address.valid){
                    this.no_result = false;
                    let location = this.lat + "," + this.long;
                    //var n = str.includes("world");
                    let address;
                    if(this.search_address.includes(this.search_postcode)){
                        address = this.search_address;
                    }else{
                        address = this.search_address + ' ' + this.search_postcode;
                    }

                    let url = '/utilities/api.json?input=' + encodeURI(address) + '&location=' + location ;
                    let GoogleMapAPI_ = Globals.AxiosGet(url);
                    let self = this;
                    this.loading = true;

                    setTimeout(() => {
                        GoogleMapAPI_.then(function (response) {                        
                            if(response.status == 200){
                                let gmap_data = JSON.parse(response.data.api_call_send.response.body);
                                if(response.data.api_call_send.response.status == 200 && gmap_data.status == "OK"){
                                    let count = gmap_data.predictions.length;
                                    self.address_search_result = gmap_data.predictions;                                    
                                    if(count > 0){
                                        console.debug(gmap_data.predictions);
                                    }else{
                                        console.error('Cant find you address');
                                    }
                                }else{
                                    self.no_result = true;
                                }
                            }                       
                        })
                        .catch(function (response) { 
                        });
                        this.loading = false;

                    }, 300);
                    
                }
                else{
                    this.address_search_result = [];
                    //this.DisableInputColor('disable_status_address');
                }
                

            }
        },
        selectOnGMAPList(_data){
            this.address_search_selected = _data;
            this.search_address = _data.description;
            this.address_search_result = [];
        }
        
    },
    mounted () {
        this.$validator.localize('en', this.dictionary);
        if(this.mountedData.postcode != undefined){
            this.is_manual = true;
            this.state = this.mountedData.state;
            this.postcode = this.mountedData.postcode
            this.address = this.mountedData.address
            this.street_no = this.mountedData.street_number;
            let res = this.Filter(this.postcode);
            this.PushToAUSuburb(res);
            this.EnableInputColor('disable_manual_address');
            this.suburb = this.mountedData.suburb;
        }
    }
}


</script>

<style lang="scss" scoped>
    .standard-form .v-input.bggray  .v-input__slot{
        background-color: #AAAAAA !important; /* forced overlay */
    }

    #formNewAddress, #SearchAddress {
        width: 100%;
    }

    .main_container {
        background: #F3F3F3;
    }

    .with_back_btn_con, .btn_container{
        background: #fff;
    }

    .btn_container { padding: 10px;}
    .btn_container button { display: block;margin:0 auto;}

    .icon_span{margin-left:5px;}
    .icon_span svg {vertical-align:middle}

    .pac-container{ border:0px;box-shadow: 0px !important;margin-top:10px;}
    .pac-item-selected {box-shadow: 0px !important;}
    .relative { position: relative;}
    .circle_loading {position: absolute; right:18px; top:44px;}
    .absolute { position: absolute;}

    .search_results{
        border: 2px solid rgba(0,0,0,.54);
        top: 87px;
        width: 100%;
        background:#fff;
        border-top-left-radius:4px;
        border-top-right-radius:4px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        z-index: 1;
        max-height: 250px;
        overflow-y: auto;
    }

    .search_results_con{
        padding:10px;
        border-bottom:1px solid rgba(84,84,84,0.5); //UIColor(red:0.84, green:0.84, blue:0.84, alpha:1)
    }

    .search_results_con:hover{
        cursor: pointer;
        background: #F3F3F3;
    }

    .powered_by_google_con{text-align: right;}
    .powered_by_google {width: 15%;}
</style>
